import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { ExtensionBadge } from '~/components/shared/ExtensionBadge'
import { formatPhoneNumber } from '~/utils/formatter'

import { toNounCasing } from '@mangovoice/core'
import { Contact, ContactPhoneNumber } from '@mangovoice/types'

interface ContactSearchListItemProps {
  contact: Contact
  contactPhoneNumber: ContactPhoneNumber
  isExtension: boolean
}
export const ContactSearchListItem = ({
  contact,
  contactPhoneNumber,
  isExtension,
}: ContactSearchListItemProps) => {
  return (
    <Flex
      flexDirection="row"
      width="100%"
      height="auto"
      bg="transparent"
      p="0.75rem"
      cursor="pointer"
      userSelect="none"
    >
      <Flex flex="1" flexShrink="0" gap="2.5rem" alignItems="center">
        <Text noOfLines={1}>
          {toNounCasing(`${contact.given_name} ${contact.family_name}`)}
        </Text>
      </Flex>
      <Flex flex="1" flexShrink="0" gap="2.5rem" alignItems="center">
        <Text noOfLines={1}>
          {!isExtension && `${toNounCasing(contactPhoneNumber.label ?? '')}: `}
          {!isExtension ? formatPhoneNumber(contactPhoneNumber.number) : ''}
          {isExtension && (
            <ExtensionBadge extension={contactPhoneNumber.number} />
          )}
        </Text>
      </Flex>
    </Flex>
  )
}
